export default {
  label: {
    info_pc: "ご注文履歴などはマイページからご確認いただけます。</br>※マイページ登録をせずにご購入いただいた方はご利用できません。</br>画面右上のログインアイコンからログインしてください。",
    info_sp: "ご注文履歴などはマイページからご確認いただけます。</br>※マイページ登録をせずにご購入いただいた方は</br>ご利用できません。</br>画面右上のログインアイコンからログインしてください。"
  }
}